<template>
    <div>
        <a href="/auth/login#login" v-if="appear_logged_in.status === true">
            <div class="appear-logged-in float-left flex flex-center-v mimic-title hover">
                <span v-html="translations['auth.no_longer_signed_in']"></span>
                <div class="profile-icon">
                    <img :src="appear_logged_in.avatar">
                    <i class="fa fa-exclamation-triangle deep-shadow"></i>
                </div>
                <p>{{ appear_logged_in.name }}</p>
            </div>
        </a>
        <div v-else class="menu-login">
            <a href="/auth/login#login">
                <i class="fa fa-user"></i>
                <p>{{ translations['navigation.login'] }}</p>
            </a>
        </div>
    </div>
</template>

<script>
    import Global from '../mixins/Global.js'
    import {mapState} from 'vuex';

    export default {
        mixins: [Global],

        computed: {
            ...mapState(['appear_logged_in'])
        }
    }
</script>

<style lang="scss" scoped>
    .appear-logged-in {
        margin-top: 17px;

        img, p {
            opacity: 0.6;
        }

        p {
            margin-left: 10px;
        }

        i {
            width: 20px;
            height: 20px;
            color: darkred;
            background: #fff;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            padding: 5px;
            font-size: 10px;
            right: -10px;
            top: -9px;
        }

        .secondary-c {
            color: #fff !important;
        }
    }
</style>